/* unplugin-vue-components disabled */import script from "./OptimizeAssAIprompt.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptimizeAssAIprompt.vue?vue&type=script&lang=ts&setup=true"

import "./OptimizeAssAIprompt.vue?vue&type=style&index=0&id=4052b11f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4052b11f"]])

export default __exports__